import { useState } from 'react'

import { CheckOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons'
import { useBoolean } from 'ahooks'
import { Button } from 'antd'
import { useTheme } from 'antd-style'

import { DeptUser } from '@eastcoal/api/auth/interface'
import { updateMemberApi } from '@eastcoal/api/auth/operationMember/updateMember'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { DeptUserCascader } from '@eastcoal/shared/components/DeptUser/Cascader'

import { MemberBizManagerProps } from './interface'

export const MemberBizManager = ({
  record = {},
  updateRecord
}: MemberBizManagerProps) => {
  const { message } = useFeedback()
  const [editable, toggleEditable] = useBoolean(false)
  const [editingManager, setEditingManager] = useState<DeptUser>()

  const {
    id,
    trade,
    supervisions = [],
    businessManagerId,
    businessManagerName
  } = record

  const manager = businessManagerId
    ? { id: businessManagerId, name: businessManagerName }
    : undefined

  const onSubmit = async () => {
    const values = {
      id,
      trade,
      supervisions: supervisions.map(visitor =>
        pick(visitor, ['supervisionId', 'supervisionName'])
      ),
      businessManagerId: editingManager?.id,
      businessManagerName: editingManager?.name
    }

    await updateMemberApi(values)

    updateRecord?.(values)
    message.success('商务经理设置成功！')
    toggleEditable.setFalse()
  }

  const onEdit = () => {
    setEditingManager(manager)
    toggleEditable.setTrue()
  }

  const { volcano, green } = useTheme()
  return editable ? (
    <>
      <DeptUserCascader
        value={editingManager}
        onChange={setEditingManager as any}
      />
      <Button
        icon={<CheckOutlined style={{ color: green }} />}
        type='link'
        onClick={onSubmit}
      />
      <Button
        icon={<CloseOutlined style={{ color: volcano }} />}
        type='link'
        onClick={toggleEditable.setFalse}
      />
    </>
  ) : (
    <div style={{ alignItems: 'start', display: 'flex' }}>
      {manager?.name ?? '-'}
      <Button
        icon={<EditOutlined />}
        style={{ padding: 'unset', height: 'unset', marginInlineStart: 6 }}
        type='text'
        onClick={onEdit}
      />
    </div>
  )
}
